import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Draggable from 'react-draggable';
import { PhoneFilled, SettingFilled } from 'antd/icons';
import styled from '@emotion/styled';

const StyledCallPatient = styled.div`
  background: #dbdddf;
  width: 320px;
  height: 120px;
  position: fixed;
  bottom: 2rem;
  left: 2rem;
  border-radius: 8px;

  box-shadow:
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);

  z-index: 1001;

  &:hover {
    cursor: move;
  }

  .cp-head {
    background: #7b7b7b;
    color: white;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    height: 30px;

    p {
      padding: 4px;
      margin-left: 10px;
      font: 15px/25px Montserrat;
      font-weight: 500;
      margin-bottom: 0px;
    }
  }

  .cp-body {
    color: black;
    margin-left: 10px;
    font: 15px/25px Montserrat;
    font-weight: 500;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 90px;
  }

  .cp-end-call-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: red;
    padding: 6px 10px;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    border: 0px;
  }

  .cp-button-container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .cp-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: white;
    border: 0px;
    cursor: pointer;
    border-radius: 0px;
    height: 50%;
    width: 150px;
    box-shadow: -22px 0px 20px -20px rgba(0, 0, 0, 1);
    background-color: #7b7b7b;

    &.end-call {
      background-color: red;
    }

    &.settings {
      border-bottom-right-radius: 8px;
    }
  }

  .cp-icon-container {
    width: 20px;
    margin-right: 6px;
  }
`;

type CallPatientProps = {
  name: string;
  number: string;
  audioCallStatusText: string;
  onClickHangupCall: () => void;
  setDeviceModalOpen: (val: boolean) => void;
};

const CallPatient = ({
  name,
  number,
  audioCallStatusText,
  onClickHangupCall,
  setDeviceModalOpen
}: CallPatientProps) => {
  const { t } = useTranslation('common');
  const isMobileOrTablet = 'ontouchstart' in document.documentElement;
  const nodeRef = useRef<HTMLDivElement>(null);

  const CallPatientModal = () => (
    <>
      <div className="cp-head">
        <p>{audioCallStatusText}</p>
      </div>
      <div className="cp-body">
        <div>{name}</div>
        <div className="cp-button-container">
          <button
            type="button"
            className="cp-button end-call"
            onClick={() => {
              onClickHangupCall();
            }}
            data-testid="disconnect-call-button"
          >
            <div className="cp-icon-container">
              <PhoneFilled
                style={{
                  fontSize: '20px'
                }}
              />
            </div>
            <div>{t('End call')}</div>
          </button>
          <button
            type="button"
            className="cp-button settings"
            onClick={() => setDeviceModalOpen(true)}
            data-testid="call-settings-button"
          >
            <div className="cp-icon-container">
              <SettingFilled
                style={{
                  fontSize: '20px'
                }}
              />
            </div>
            <div>{t('Audio devices')}</div>
          </button>
        </div>
      </div>
    </>
  );

  return (
    <>
      {isMobileOrTablet ? (
        <StyledCallPatient className="cp-main">
          <CallPatientModal />
        </StyledCallPatient>
      ) : (
        <Draggable nodeRef={nodeRef as React.RefObject<HTMLElement>}>
          <StyledCallPatient ref={nodeRef} className="cp-main">
            <CallPatientModal />
          </StyledCallPatient>
        </Draggable>
      )}
    </>
  );
};

export default CallPatient;
